<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Modification de boutique</h2> <br>
                <form @submit.prevent="onUpdateBoutique">
                    <fieldset class="uk-fieldset">
                        <div uk-grid class="uk-margin">
                            <div class="uk-width-1-2">
                                <input class="uk-input" type="text" v-model="boutique.nom_boutique" placeholder="Nom de l'entreprise" required>
                            </div>
                            <div class="uk-width-1-2">
                                <input class="uk-input" type="text" v-model="boutique.nom_responsable" placeholder="Nom du responsable" required>
                            </div>
                        </div>
                        <div class="uk-margin" uk-grid>
                            <div class="uk-width-1-2">
                                <input class="uk-input" type="text" v-model="boutique.adresse" placeholder="Situation géographique" required>
                            </div>
                            <div class="uk-width-1-2">
                                <input class="uk-input" type="number" v-model="boutique.contact_boutique" placeholder="Numéro à contacter" required>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label >Type de paiement</label>
                            <select v-model="boutique.type_paiement" class="uk-select">
                                <option>Wave</option>
                                <option>Orange money</option>
                                <option>Moov money</option>
                                <option>MTN money</option>
                                <option>Espèces</option>
                                <option>Virement Bancaire</option>
                            </select>
                        </div>
                        <div class="uk-margin">
                            <input class="uk-input" type="text" v-model="boutique.adresse_paiement" placeholder="Contact / Adresse de reception" required> 
                        </div>
                    </fieldset>
                    <div class="d-flex justify-content-center">
                            <button class="btn-round my-1 border-0 px-5 uk-button uk-button-primary" style=" color:#fff;  font-size:1em !important; ">Mettre à jour</button>
                    </div>
                </form>
            </div>
        </div>
        
        

    </div>
    
</template>
<script>
    import { dbstore } from '../../main';
    import Swal from "sweetalert2";
    
    export default {
        data(){
            return{
                boutique: {},
            };
        },

        created() {
            let dbRefStore = dbstore.collection('boutiques').doc(this.$route.params.id);
            dbRefStore.get().then((doc) => {
                this.boutique = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        },

        methods: {
            onUpdateBoutique(event) {
                event.preventDefault()
                dbstore.collection('boutiques').doc(this.$route.params.id)
                .update(this.boutique).then(() => {
                    console.log("Mise à jour effectuée!");
                    this.$router.push('/admin/boutiques');
                    Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Mise à jour éffectuée',
                    showConfirmButton: true,
                    timer: 4000,
                    allowOutsideClick: false,
                    })
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
        

    }

</script>